import request, { get, post } from '@/api/clients/portal-client'

// 获取项目列表
export function getProjectList(toolId) {
  return get('/userprojects/list', toolId ? { toolId } : {})
}

// 新增项目
export function addProject(projectName, toolId) {
  return post('/userprojects/add', {
    projectName,
    toolId
  })
}

// 删除项目
export function deleteProject(id) {
  return post('/userprojects/delete', {
    id
  })
}

// 重命名项目
export function renameProject(id, newName) {
  return post('/userprojects/rename', {
    id,
    newName
  })
}

// 复制项目
export function copyProject(id) {
  return post('/userprojects/copy', {
    id
  })
}

// 获取项目明细信息 - 恢复原来的工作版本
export function getProjectsItemInfo(projectId) {
  return request({
    url: '/userprojectsitem/getProjectsItemInfo',
    method: 'get',
    params: {
      projectId: projectId // 恢复原来的参数名
    }
  })
}

// 添加或更新项目参数 - 恢复原来的工作版本
export function addOrUpdateProjectParams(projectId, paramsJson) {
  return request({
    url: '/userprojectsitem/addOrUpdate',
    method: 'post',
    data: {
      projectId: projectId, // 项目ID
      paramsJson            // JSON参数
    }
  })
}
